import { render, staticRenderFns } from "./SubTree.vue?vue&type=template&id=6ed8aba3"
import script from "./SubTree.vue?vue&type=script&lang=js"
export * from "./SubTree.vue?vue&type=script&lang=js"
import style0 from "./SubTree.vue?vue&type=style&index=0&id=6ed8aba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports